export default __webpack_public_path__ + "static/media/1907.8f974bf2.png";